"use client"

import Image from "next/image"
import { cn } from "@/lib/utils"

interface TkMonogramProps {
  className?: string
  animated?: boolean
}

export function TkMonogram({ className, animated = true }: TkMonogramProps) {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      {/* Deliberately no `priority` and no `loading="eager"`: in Next 14
          BOTH inject a <head> image preload that competes with CSS/fonts in
          the LCP-critical window on every page, and the logo is never the
          LCP element (text is — measured 2026-08). The default (lazy) is
          fine here despite being above the fold: Chrome starts in-viewport
          lazy fetches right after layout, so the only cost is the ~2.6KB
          mark painting a beat after the wordmark text on slow first loads. */}
      <Image
        src="/tallkarol-monogram-logo.png"
        alt="Tall Karol"
        width={32}
        height={32}
        className="h-full w-full object-contain"
        sizes="32px"
        quality={90}
        />
    </div>
  )
}

